import PhoneNumber from 'awesome-phonenumber'

// P43-04: the phone-number text rules of the mobile login field (LoginView,
// P39 TR-042), for the one other place a student types a mobile number: adding
// it to an existing account from Edit Profile. LoginView keeps its own copy;
// the two are deliberately identical.
//
// What the field may hold: Latin, Persian and Arabic-Indic digits, the usual
// phone punctuation (+ - ( ) .), spaces, and the invisible direction marks a
// paste from Persian text carries. Anything else is refused whole, never
// stripped: libphonenumber drops a stray letter and maps three or more to
// keypad digits, so `0912ABC4567` would otherwise become a different, valid
// number.
const PHONE_TEXT_ALLOWED = /^[0-9\u0660-\u0669\u06f0-\u06f9+\-().\s\u061c\u200e\u200f\u202a-\u202e\u2066-\u2069]*$/

export const isAllowedPhoneText = text => PHONE_TEXT_ALLOWED.test(text || '')

// An Iranian mobile number only. A number typed with an explicit foreign
// country code parses as that country and must not pass, and a valid landline
// must not pass as an account identity. `e164` is always a Latin-digit +98...
// string, so a bare 0912... or a Persian-digit string never reaches the API.
export function parseIranMobile(text) {
  const parsed = new PhoneNumber(text || '', 'IR')
  const isValid =
    isAllowedPhoneText(text) &&
    parsed.isValid() &&
    parsed.isMobile() &&
    parsed.getRegionCode() === 'IR'
  return {
    isValid,
    e164: isValid ? parsed.getNumber('e164') : '',
    formatNational: parsed.getNumber('national') || text || '',
  }
}
